import { render } from "./PropertyBuilder.vue?vue&type=template&id=b5eed178"
import script from "./js/PropertyBuilder.js?vue&type=script&lang=js&external"
export * from "./js/PropertyBuilder.js?vue&type=script&lang=js&external"

import "./PropertyBuilder.vue?vue&type=style&index=0&id=b5eed178&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__